import { types } from "../action-types";

const initialState = {
    loading: false,
    sugesstions: [],
    recentsearch:[],
    trendingJobs:[],
    error: false,
    keywords:[]
};

const getSearchSuggestionReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SEARCH_SUGGESTIONS_REQUESTED:
            return {
                ...state,
                loading: true,
            };

        case types.SEARCH_SUGGESTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                sugesstions: action.payload,
                error: false,
            };
        case types.SEARCH_SUGGESTIONS_FAILURE:
            return {
                ...state,
                loading: false,
                sugesstions: [],
                error: true,
            };
     
//keywords suggestions
case types.FETCH_KEYWORDS_INIT:
            return {
                ...state,
                loading: true,
            };

        case types.FETCH_KEYWORDS_SUCCESS:
            return {
                ...state,
                loading: false,
                keywords: action.payload,
                // error: false,
            };
        case types.FETCH_KEYWORDS_FAILURE:
            return {
                ...state,
                loading: false, 
                // error: true,
            };
//** */
//fetch recent searches


        case types.GET_RECENT_SEARCHES_INIT:
            return {
                ...state,
                loading: true,
            };

        case types.GET_RECENT_SEARCHES_SUCCESS:
            return {
                ...state,
                loading: false,
                recentsearch: action.payload,
                error: false,
            };
        case types.GET_RECENT_SEARCHES_FAILURE:
            return {
                ...state,
                loading: false,
                recentsearch: [],
                error: true,
            }
        
        //CLEAR RECENT SEARCH
        

  case types.CLEAR_RECENT_SEARCH_INIT:
    // console.log("clear recent init");
            return {
                ...state,
                loading: true,
            };

        case types.CLEAR_RECENT_SEARCH_SUCCESS:
            // console.log("clear recent success", action.payload);
            return {
                ...state,
                loading: false,
                recentsearch: action.payload,
                error: false,
            };
        case types.CLEAR_RECENT_SEARCH_FAILURE:
            // console.log("clear recent failure", action.payload);
            return {
                ...state,
                loading: false,
                recentsearch: action.payload,
                error: true,
            }
// fetch trending jobs

            case types.GET_TRENDING_JOBS_INIT:
                return {
                    ...state,
                    loading: true,
                };
    
            case types.GET_TRENDING_JOBS_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    trendingJobs: action.payload,
                    error: false,
                };
            case types.GET_TRENDING_JOBS_FAILURE:
                return {
                    ...state,
                    loading: false,
                    trendingJobs: [],
                    error: true,
                };
        
                    
        default:
            return state;
    }
}


export default getSearchSuggestionReducer;
